import { api } from './api'
import type { MessagesToday } from './messages-today-types'

export type { MessagesToday }
// Independent of the page's main read: Stage 5 paints the approved slots without delaying working cards.
// No browser cache or shared "latest" value: a response can never ride into a different business.
export async function fetchMessagesToday(): Promise<MessagesToday> {
  try { return await api<MessagesToday>('/api/messages/today') }
  catch { return { day: null, sent: null, target: null, left: null, homes: null, bookedWeekPence: null, bookedTodayPence: null, bookedDays: null, streak: null, handledToday: null } }
}
